import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { CustomerUser } from '@src/app/models/customeruser';
import { Customer } from '@src/app/models/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerpageService {

  constructor(private http:HttpClient) { }

  addCustomerUser(customerUser:CustomerUser){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post(environment.apiUrl+
      '/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+
      customerUser.customerId+
      '/user/'
      +customerUser.userId,JSON.stringify(customerUser),httpOptions);
  }


  getCustomer(customerId:string,pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Customer>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/pit/'+pit,httpOptions);
  }
  updateCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,JSON.stringify(customer),httpOptions)
  }
  deleteCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,httpOptions)
  }
}
